export default "__VITE_ASSET__Dg0K7Fnt__"